import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./SubscriptionQuantityForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelChangeSubscriptionQuantity} from "../../actions/AccountApiActions";
import {fromJS, Map} from "immutable";
import {validateGreaterThan} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validateGreaterThan(errors, values, "quantity", 0);
  return errors.toJS();
}

class ChangeSubscriptionQuantityFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("subscriptionId", this.props.subscriptionId)
                              .set("productSku", this.props.productSku);
    return this.props.changeSubscriptionProductQuantity(updatedValues.toJS())
      .then((response) => {
        if (response.data.changeSubscriptionProductQuantity.errors.length <= 0) {
          this.props.cancelChangeSubscriptionQuantity();
        } else {
          let errors = createValidationErrors(response.data.changeSubscriptionProductQuantity.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelChangeSubscriptionQuantity();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    const info = fromJS(data.subscriptionProductInfo);
    console.log(info.toJS());
    let initialValues = {
      quantity: info.get("quantity")
    }
    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        productTitle={info.get("productTitle")}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}

const GET_SUBSCRIPTION = gql`
  query subscriptionProductInfo($subscriptionId: ID!, $productSku: String!) {
    subscriptionProductInfo(subscriptionId: $subscriptionId, productSku: $productSku) {
      productSku
      productTitle
      quantity
    }
  }
`;

const CHANGE_SUBSCRIPTION_QUANTITY = gql`
  mutation changeSubscriptionProductQuantity($data: SubscriptionProductQuantityInput!) {
    changeSubscriptionProductQuantity(input: $data) {
      errors { key message }
    }
  }
`;

const withProductQuery = compose(
  graphql(GET_SUBSCRIPTION, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        subscriptionId: props.subscriptionId,
        productSku: props.productSku
      }
    })
  }),
  graphql(CHANGE_SUBSCRIPTION_QUANTITY, {
    props: ({ mutate }) => ({
      changeSubscriptionProductQuantity: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

const ChangeSubscriptionQuantityFormContainerWithData = withProductQuery(ChangeSubscriptionQuantityFormContainer);

export default connect(null, {cancelChangeSubscriptionQuantity})(ChangeSubscriptionQuantityFormContainerWithData);